import { ThemeProvider } from "@mui/material";
import { Fragment } from "react";
import React from "react";
import { EventTheme } from "./theme/EventTheme";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "react-query";
import EventHome from "./components/Home";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import RegistrationForm from "./components/formbuilder/RegistrationForm";
import "react-quill/dist/quill.snow.css";
import QueryFormTrialVersion from "./components/QueryFormTrialVersion";
import PricingDisplay from "./components/pages/PricingDisplay";
import ContactUs from "./components/pages/ContactUs";
import FaqsPage from "./components/pages/Faqs";
import FeaturesPage from "./components/pages/FeaturesPage";
import BookTrial from "./components/pages/BookTrail";
import WelcomeInviteMember from "./components/pages/WelcomeInviteMember";
import PasswordSetPage from "./components/pages/PasswordSetPage";
const queryClient = new QueryClient();

const App = () => {
  return (
    <ThemeProvider theme={EventTheme}>
      <QueryClientProvider client={queryClient}>
        <Fragment>
          <BrowserRouter>
            <ToastContainer autoClose={1500} />
            <Routes>
              <Route
                path="/build-registration-form"
                element={<RegistrationForm />}
              />
              <Route path="/pricing" element={<PricingDisplay />} />
              <Route path="/contactus" element={<ContactUs />} />
              <Route path="/faq" element={<FaqsPage />} />
              <Route path="/book-trial" element={<BookTrial />} />
              <Route path="/features" element={<FeaturesPage />} />
              <Route
                path="/welcome-invite-member/:id"
                element={<WelcomeInviteMember />}
              />
              <Route
                path="/pwd-reset-link-member/:id"
                element={<PasswordSetPage />}
              />
              <Route path="/query-form" element={<QueryFormTrialVersion />} />
              <Route path="/" element={<EventHome />} />
            </Routes>
          </BrowserRouter>
        </Fragment>
      </QueryClientProvider>
    </ThemeProvider>
  );
};

export default App;
